import { apiClient } from '../../api/client';

export async function getWorkscoreConfigs() {
  const response = await apiClient.get('/workscore/configs');
  return response.data;
}

export async function getWorkscoreAssessment(slug) {
  const response = await apiClient.get(`/workscore/assessment/${slug}`);
  return response.data;
}

export async function startWorkscoreAttempt({ slug, profilePhoto, questionsPerSection }) {
  const response = await apiClient.post('/workscore/start', {
    slug,
    questionsPerSection,
    profilePhoto: profilePhoto || null,
    source: profilePhoto ? 'webcam' : null,
    refToken: sessionStorage.getItem('assessment_ref') || null
  });
  return response.data;
}

export async function submitWorkscoreAttempt(payload) {
  const response = await apiClient.post('/workscore/submit', {
    ...payload,
    refToken: sessionStorage.getItem('assessment_ref') || null
  });
  return response.data;
}

export async function getWorkscoreResult(attemptId) {
  const response = await apiClient.get(`/workscore/result/${attemptId}`);
  return response.data;
}
